import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import { useParams } from "react-router-dom";
import LdsButton from "../components/LdsButton";
import LdsLink from "../components/LdsLink";

import { useValidateTokenMutation } from "../store/services/authServerApi";
import LdsValidationError from "../components/LdsValidationError";
import LdsTextField from "../components/LdsTextField";

// validation schema
import { ResetPasswordSchema } from "../validationSchema/ResetPasswordSchema";

//services
import { useChangePasswordMutation } from "../store/services/authServerApi";
import { BootstrapAlert } from "../components/BootstrapAlert";
import { forceNavigate } from "../store/utils/helper";

const ResetPassword = () => {
  const { token } = useParams();

  const [
    validateToken,
    {
      isLoading,
      error: { data: { status, message: errorMessage } = {} } = {},
      data: { data: refreshedToken } = {},
    },
  ] = useValidateTokenMutation();

  console.log(
    "isLoading, status, errorMessage, successMessage :>> ",
    isLoading,
    status,
    errorMessage,
    refreshedToken
  );
  if (refreshedToken) sessionStorage.setItem("token", refreshedToken);

  const [
    changePassword,
    {
      isLoading: cpLoading,
      error: { data: { message: changePasswordErrorMsg } = {} } = {},
      data: { message: changePasswordSuccessMsg } = {},
    },
  ] = useChangePasswordMutation();

  if (changePasswordSuccessMsg) {
    forceNavigate("/");
  }

  console.log(
    "cpLoading, error, data :>> ",
    cpLoading,
    changePasswordErrorMsg,
    changePasswordSuccessMsg
  );

  useEffect(() => {
    validateToken(token);
  }, []);
  const handleSubmit = (data) => {
    changePassword(data);
  };

  return (
    <>
      <main className="section">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-sm-12 col-md-6">
              <h1 className="blue text-uppercase b text-center">
                Reset Password
              </h1>
            </div>
          </div>
          <div className="row justify-content-center mt-4">
            <div className="col-sm-12 col-md-4">
              <BootstrapAlert variant="danger" message={errorMessage} />
              <BootstrapAlert
                variant={changePasswordErrorMsg ? "danger" : "success"}
                message={
                  changePasswordErrorMsg
                    ? changePasswordErrorMsg
                    : changePasswordSuccessMsg
                }
              />
              <Formik
                initialValues={{
                  password: "",
                  confirmPassword: "",
                }}
                validationSchema={ResetPasswordSchema}
                onSubmit={handleSubmit}
              >
                {({ handleChange, errors, touched }) => (
                  <Form>
                    <div className="row">
                      <div className="col">
                        <LdsTextField
                          maxLength={100}
                          disabled={!refreshedToken}
                          onChange={handleChange}
                          label="Enter Password"
                          labelRequired
                          name="password"
                          id="password"
                          type="password"
                          className="lds-text-field mb-3"
                          error={errors.password && touched.password}
                        />
                        {errors.password && touched.password && (
                          <LdsValidationError id="errpassword">
                            {errors.password}
                          </LdsValidationError>
                        )}
                        <LdsTextField
                          maxLength={100}
                          disabled={!refreshedToken}
                          onChange={handleChange}
                          label="Confirm Password"
                          labelRequired
                          name="confirmPassword"
                          id="confirmPassword"
                          type="password"
                          className="lds-text-field mb-3"
                          error={
                            errors.confirmPassword && touched.confirmPassword
                          }
                        />
                        {errors.confirmPassword && touched.confirmPassword && (
                          <LdsValidationError id="errconfirmPassword">
                            {errors.confirmPassword}
                          </LdsValidationError>
                        )}
                        <div className="col-sm-12 col-md-6 offset-md-3">
                          <LdsButton
                            classes="blue-button mt-3 d-block mx-auto"
                            type="submit"
                            disabled={isLoading || !refreshedToken}
                          >
                            Submit
                          </LdsButton>
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>

              <div className="row">
                <div className="col-sm-12 col-md-6 offset-md-3">
                  <LdsLink
                    href="/login"
                    useIcon
                    icon="arrow-left"
                    iconOnly
                    contextualIcon
                    iconLabel="My Account"
                    iconPosition="before"
                    className="mt-5 d-block orange text-center"
                  >
                    Back to login
                  </LdsLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ResetPassword;
